import { useReduxActions } from 'hooks/useReduxActions';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { userSelector } from 'store/selectors';
import TextInput from 'components/TextInput';
import Button from 'components/Button';
import Avatar from 'components/Avatar';
import UploadAvatarModal from 'components/modals/UploadAvatarModal';

const ProfileContainer = styled.div`
  margin: 24px 32px;
  display: flex;
  justify-content: flex-start;
  gap: 40px;
`;

const InputBlockContainer = styled.div`
  > * {
    margin-top: 16px;
  }
`;

const AvatarContainer = styled.div`
  margin: 32px 0 0 32px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  width: 250px;
`;

const ClientProfile = () => {
  const user = useSelector(userSelector);
  const { t } = useTranslation();
  const actions = useReduxActions();
  const [input, setInput] = useState({
    ID: '',
    email: '',
    first_name: '',
    last_name: '',
    phone: '',
    company_name: '',
  });
  const [isOpenModal, setIsOpenModal] = useState(false);

  const INPUTS = [
    {
      id: 0,
      title: t('client.profile.nav.profile.client_id'),
      disabled: true,
      position: 'left',
      field: 'ID',
    },
    {
      id: 1,
      title: t('client.profile.nav.profile.email'),
      disabled: false,
      position: 'right',
      field: 'email',
    },
    {
      id: 2,
      title: t('client.profile.nav.profile.first_name'),
      disabled: false,
      position: 'left',
      field: 'first_name',
    },
    {
      id: 3,
      title: t('client.profile.nav.profile.last_name'),
      disabled: false,
      position: 'left',
      field: 'last_name',
    },
    {
      id: 4,
      title: t('client.profile.nav.profile.phone'),
      disabled: false,
      position: 'right',
      field: 'phone',
    },
    {
      id: 5,
      title: t('client.profile.nav.profile.company_name'),
      disabled: false,
      position: 'left',
      field: 'company_name',
    },
  ];

  const handleInputValueChange = field => e => {
    const { value } = e.target;
    setInput(prev => {
      return {
        ...prev,
        [field]: value,
      };
    });
  };

  const handleInputBlur = field => () => {
    actions.updateClientProfile({ [field]: input[field] });
  };

  const handleOpenModal = () => {
    setIsOpenModal(true);
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
  };

  useEffect(() => {
    if (!!Object.values(user).length) {
      const {
        phone = '',
        first_name = '',
        last_name = '',
        company_name = '',
      } = user.profile;
      setInput({
        ...input,
        company_name,
        first_name,
        last_name,
        phone,
        email: user.email,
      });
    }
  }, [user]); // eslint-disable-line

  return (
    <>
      <AvatarContainer onClick={handleOpenModal}>
        <Avatar size="big" image={user.profile?.avatar?.url} />
        {user.profile?.avatar?.url
          ? t('client.profile.change.photo')
          : t('client.profile.upload.photo')}
      </AvatarContainer>
      <ProfileContainer>
        <InputBlockContainer>
          {INPUTS.filter(item => item.position === 'left').map(item => (
            <TextInput
              key={item.id}
              size="medium"
              title={item.title}
              disabled={item.disabled}
              value={input[item.field]}
              onChange={handleInputValueChange(item.field)}
              onBlur={handleInputBlur(item.field)}
            />
          ))}
          <Button size="medium" variant="primary">
            {t('client.profile.nav.profile.change_password')}
          </Button>
          <Button size="medium" variant="primary">
            {t('client.profile.nav.profile.delete_account')}
          </Button>
        </InputBlockContainer>
        <InputBlockContainer>
          {INPUTS.filter(item => item.position === 'right').map(item => (
            <TextInput
              key={item.id}
              size="medium"
              title={item.title}
              disabled={item.disabled}
              value={input[item.field]}
              onChange={handleInputValueChange(item.field)}
              onBlur={handleInputBlur(item.field)}
            />
          ))}
        </InputBlockContainer>
      </ProfileContainer>
      <UploadAvatarModal isOpen={isOpenModal} onClose={handleCloseModal} />
    </>
  );
};

export default ClientProfile;
